module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"login":"My Account","profile":"Profile","cart":"Cart","home":"Home","offers":"Sale","categories":"Categories"},"ar":{"login":"تسجيل الدخول","profile":"الملف الشخصي","cart":"عربة التسوق","home":"الرئيسية","offers":"عروض","categories":"الفئات"}}')
  delete Component.options._Ctor
}
